import React, { useEffect, useState } from 'react'
import CustomDataTable from '../../../../Components/Others/CustomDataTable';
import { useFormik } from 'formik';
import { useLocation, useParams } from 'react-router-dom';
import * as yup from 'yup';
import UseGetDataSearch from '../../../../Components/Hooks/useFetchDataBySearch';
import { GetAccess, GetNotUseRole } from '../../../../Components/Utils/roles';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import { CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import { NuDate } from '../../../../Components/Utils/Input';
import NuDateFormate, { formatDate } from '../../../../Components/Utils/NuDate';

import axiosInstance from '../../../../Services/axiosCommon';
import CloseIcon from '../../../../Components/Icons/Close';
import TicketsLayout from '../TicketsLayout';
import MobileClientTicketIndex from '../../../Mobile/Tickets/ClientTicket/MobileClientTicketIndex';
import ImportClientTicket from './ImportClientTicket';
import MultiEditClientTicket from './MultiEditClientTicket';
import useFetchMDIndex from '../../../../Components/Hooks/useFetchMDIndex';




function ClientTicketsIndex() {
  const { officeId } = useParams();
  const [showFilterDialog, setShowFilterDialog] = useState(false);


  const [screenSize, setScreenSize] = useState({
         width: window.innerWidth,
       });
     
       useEffect(() => {
         const handleResize = () => {
           setScreenSize({
             width: window.innerWidth,
           });
         };
     
         window.addEventListener("resize", handleResize);
     
         return () => {
           window.removeEventListener("resize", handleResize);
         };
       }, []);

       const { value: TicketType,getData:refTicketType } = useFetchMDIndex(
        `/dropdown/dropdown-details/`,
        "Ticket_Type",showFilterDialog
      );  
      
      const { value: Priority,getData:refPriority } = useFetchMDIndex(
        `/dropdown/dropdown-details/`,
        "priority",showFilterDialog
      );  
      
      const { value: Status,getData:refStatus } = useFetchMDIndex(
        `/dropdown/dropdown-details/`,
        "Status_Support_Tickets",showFilterDialog
      ); 

 const location = useLocation();
 const currentPage= location.state?.currentPage
 const searchQuery= location.state?.searchQuery
 const [page, setPage] = useState(currentPage||1)
 const [pageCount, setPageCount] = useState(localStorage.getItem("perPageView")||20)
 const state = location.state;
 const [filter, setFilter] = useState(
   state?.priority || state?.category ? true : false
 );
   const [filterProps, setFilterProps] = useState({
 
     status:"",
     ticketType:"",
     priority:"",
   });
 const [params, setParams] = useState({
   page: page,
   per_page: pageCount,
   search:searchQuery||"",

   status:"",
     ticketType:"",
     priority:state?.priority? state.priority :"",
  //  deadLineTo:"",
  //  approvalStatus:state?.approvalStatus? state.approvalStatus :"",
  //  category:state?.category? state.category :"",
 });

 const clearFilter = ()=> {
   setParams({...params,status:"", ticketType:"", priority:"",deadLineFrom:"", deadLineTo:"",approvalStatus:"",category:"",})
   formik.values.status=""
   formik.values.ticketType=""
   formik.values.priority=""
   formik.values.deadLineFrom=""
   formik.values.deadLineTo=""
   formik.values.approvalStatus=""
   formik.values.category=""



     setFilter(false)
 }

 const formik = useFormik({
   enableReinitialize: true,
   initialValues: filterProps,
   validateOnChange: false,
   validateOnBlur: false,
   validationSchema: yup.object({
     // email: yup.string().required('Email is required!'),
   }),
   onSubmit: async (value, { resetForm }) => {
      await new Promise((resolve) => setTimeout(resolve, 300)); // give Formik time to set isSubmitting

     setParams({...params,status:value.status, ticketType:value.ticketType, priority:value.priority, deadLineFrom:value.deadLineFrom, deadLineTo:value.deadLineTo,approvalStatus:value.approvalStatus,category:value.category})
     closeFilterDialog();
     setFilter(true)
     setFilterProps({
       status:"",
       ticketType:"",
       priority:"",
       deadLineFrom:"",
       deadLineTo:"",
       approvalStatus:"",
       category:""
     });
   }
 })

 const { data, totalCount, getData,dataLoading } = UseGetDataSearch( `/tickets/tickets-listing`,params);

 const defaultHeader = [
  {
    title: "Ref.",
    width: "12.85%",
    isLink: true,
    id: "ticketId",
    link: `/tickets/client-tickets/view/`,
    field: "refNumber",
    textAlign: "left",
    rowAlign: "left",
  },
  {
    title: "Ticket Type",
    width: "12.85%",
    isLink: true,
    id: "ticketId",
    link: `/tickets/client-tickets/view/`,
    field: "ticketType",
    textAlign: "left",
    rowAlign: "left",
  },
  {
    title: "Ticket Date",
    width: "12.85%",
    field: "createdAt",
    textAlign: "left",
    rowAlign: "left",
  },
 
  GetNotUseRole("client") ? {
                 title: "Client",
                 width: "12.85%",
                 field: "clientName",
                 textAlign: "left",
                 rowAlign: "left",
               }:
               {
                 title: " ",
                 width: "0.1%",
                 field: " ",
                 textAlign: "left",
                 rowAlign: "left",
               },
  {
    title: "Subject",
    width: "12.85%",
    field: "subject",
    textAlign: "left",
    rowAlign: "left",
  },
  // {
  //   title: "Response Date",
  //   width: "12.85%",
  //   type:"date",
  //   field: "responseDate",
  //   textAlign: "left",
  //   rowAlign: "left",
  // },
  
 
  {
    title: "Status",
    width: "12.85%",
    field: "status",
    textAlign: "left",
    rowAlign: "left",
  },
   {
     title: "Action",
     width: "10%",
     field: "action",
     textAlign: "center",
     rowAlign: "center",
     contents:{
       // fetcher:getData,
       id:"ticketId",
       removeValue:"refNumber",
       url:`/tickets/remove-ticket/`,
       moduleName:"Client Ticket",
       from:`/tickets/client-tickets`,
       editLink:`/tickets/client-tickets/edit/`,
       viewLink:`/tickets/client-tickets/view/`

     }
   },
 ];
 const availableHeaders = [
  
 ];

 const [showExport, setShowExport] = useState(false);
 const [exportValue, setExportValue] = useState({
  status:"",
  ticketType:"",
  priority:"",
 });
 const ExportFormik = useFormik({
   enableReinitialize: true,
   initialValues: exportValue,
   validateOnChange: false,
   validateOnBlur: false,
   onSubmit: async (value, { resetForm }) => {
     try {
       const response = await axiosInstance.get(
         `tickets/client-export?status=${value.status}&ticketType=${value.ticketType}&priority=${value.priority}`,
         {
           responseType: "blob",
         }
       );

       const pdfBlob = new Blob([response.data], {
         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
       });

       const link = document.createElement("a");
       link.href = window.URL.createObjectURL(pdfBlob);
      //  link.download = `Client Ticket ${NuDateFormate({
      //    value: new Date(),
      //    format: "DD-MMM-YYYY",
      //  })}.xlsx`;

              link.download = `Client Ticket Report ${formatDate(new Date())}.xlsx`;
      

       document.body.appendChild(link);
       link.click();

       link.parentNode.removeChild(link);
     } catch (error) {
       console.error("Error downloading the PDF:", error);
     }
   },
 });
 const closeFilterDialogebox = () => {
   setShowExport(false);
 };

 const [showEdit, setShowEdit] = useState(false)
 const [showDelete, setShowDelete] = useState(false)
 const [listofNumbers, setListofNumbers] = useState([])
 const [fullList, setFullList] = useState([])

 const selectOneFunction = (value) =>{ 
   let NewId;
   if(listofNumbers && listofNumbers.some(Item=>Item ===value)){
     NewId = listofNumbers.filter(Temp=> Temp !== value);
     setListofNumbers(NewId)
   }else{
     setListofNumbers([...listofNumbers,value])
   }
 }

 const selectMultipleFunction = (e) =>{ 

   if(e.target.checked){
     setListofNumbers(fullList)
   }else{
     setListofNumbers([])
   }
   

     }

     useEffect(()=>{
       setParams({...params,page:page,per_page:pageCount})
      },[page,pageCount])
   

     const closeFilterDialog = () => {
       setShowFilterDialog(false);
     };
 const [showImportModal, setShowImportModal] = useState(false);


 const handleImportClick = () => {
   setShowImportModal(true);
 };

 const closeModal = () => {
   setShowImportModal(false);
 };

 useEffect(()=>{
   let tempArr = []
   data && data.forEach(i=>{
    
     tempArr.push(i?.ticketId)
   });
   setFullList(tempArr)
 },[data])

 const [valueOfSearch,setValuesofSearch] = useState("")
  function searchFunction(e) {

    
    setValuesofSearch(e?.target?.value)
    setParams({ ...params, search: e?.target?.value, page:1 });
    setPage(1)
  }


   // Define your actual API delete function for a single schedule
  const deleteSchedule = async (ticketId) => {
    const response = await axiosInstance.delete(`/tickets/remove-ticket/${ticketId}`);
    return response; // Return the entire Axios response
  };


 return (
   <>
   <TicketsLayout 
     setOpen={setShowImportModal}
     searchFun={searchFunction}
     searchValue={valueOfSearch}

     // getData={getData}
     isFilter={filter}
     neededSearch={true}
     newfilter={true}
 officeId={officeId}

     setFilterOpen={setShowFilterDialog}
     ClearFilter={clearFilter}
     CreateAccess={GetAccess("client_tickets_create")}
     ImportAccess={GetAccess("testing_and_commisioning_module")}
           ExportAccess={GetAccess("client_tickets_export")}
           setOpenExport={setShowExport}
           total={totalCount}

     // officeId={officeId}
     // projectID={projectID}
       >


        
{
 screenSize.width <= "786" ?(<>
 <div className=' w-full h-[calc(100vh-205px)] bg-white mt-1 rounded-lg shadow-lg overflow-hidden'>
 <MobileClientTicketIndex
 data={data}
 total={totalCount}
 pageIndex={page}
 setPageIndex={setPage}
 dataCount={pageCount}
 setDataCount={setPageCount}
 officeId={officeId}
 getData={getData}

 />
 </div>
 </>):(<>


   <div className='w-full h-full  '>
     {/* <div className='w-full flex justify-between items-center'>
       <Breadcrumb
         items={[
           { name: "Procurement" },
           { name: "YPR" },
         ]} />
       <div className=' flex gap-2'>
       <SearchBar
             handleChange={(e) =>{
               setParams({ ...params, search: e.target.value, page:1 });
               setPage(1)
             }}
             value={params.search||searchQuery}
           />  <FilterButton  handleClick={()=>setShowFilterDialog(true)} />
         {filter && <FilterButton  handleClick={()=>clearFilter()} label='Clear'/>} */}
       
         {/* {GetAccess("purchase_request_create") && <ImportButton handleClick={handleImportClick} />} */}
         {/* {GetAccess("purchase_request_create") && <Link to={`/main/${officeId}/procurement/purchase-requests/create`}><CreateButton label='YPR' /></Link>}
       </div>
     </div> */}

     <CustomDataTable 
     fetcher={getData}
       data={data} 
       availableHeaders={availableHeaders} 
       defaultHeader={defaultHeader}
       bodyHeight='max-h-[calc(100vh-260px)]'
       height='h-[calc(100vh-160px)]'
       total={totalCount}
       pageIndex={page}
       setPageIndex={setPage}
       dataCount={pageCount}
       setDataCount={setPageCount}
       title='Client Ticket'
       storageName="clientTicketTable"
       selectOneFunction={selectOneFunction}
       setShowDelete={setShowDelete}
       showDelete={showDelete}
       setShowEdit={setShowEdit}
       showEdit={showEdit}
       listofNumbers={listofNumbers}
       hasMultiEdit={true}
       selectMultipleFunction={selectMultipleFunction}
       fullList={fullList}
       getById="ticketId"
       editAccess="client_tickets_edit"      
       deteleAccess="client_tickets_delete" 
       dataLoading={dataLoading}
       searchQuery={params?.search!=""?params?.search:""}
       // dateShow={true}
          hasMultiDelete={true}
                identifierKey="refNumber"
                deleteSingleItem={deleteSchedule}
       />
   </div>

</>)}

 

       </TicketsLayout>

       {showFilterDialog && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <h2 className="text-xl mb-4">Filter </h2>
            <form onSubmit={formik.handleSubmit}>
              <div className="flex flex-col mb-4">
              <FormikSelectTwo
              label="Priority"
              Options={Priority}
              formik={formik}
              placeholder="Choose"
              name="priority"

              width="w-full"
              displayProperty={"Priority"}
              propertyName={"priority"}
              getFunc={refPriority}

            /> 

<FormikSelectTwo
              label="Ticket Type"
              Options={TicketType}
              formik={formik}
              placeholder="Choose"
              name="ticketType"

              width="w-full"
              displayProperty={"Ticket Type"}
              propertyName={"Ticket_Type"}
              getFunc={refTicketType}

            /> 
           <FormikSelectTwo
              label="Status"
              Options={Status}
              formik={formik}
              placeholder="Choose"
              name="status"

              width="w-full"
              displayProperty={"Status"}
              propertyName={"Status_Support_Tickets"}
              getFunc={refStatus}
              
            />
              </div>
              <div className="flex justify-end gap-2">
                <CancelButton handleClick={closeFilterDialog} />
                                <SubmitButton name="Apply" isLoading={formik.isSubmitting} />

              </div>
            </form>
          </div>
        </div>
      )}

      {showEdit && (
        <MultiEditClientTicket
          data={listofNumbers}
          getData={getData}
          onClose={() => setShowEdit(false)}
        />
      )}
      {showImportModal && (
        <ImportClientTicket
          show={showImportModal}
          onClose={closeModal}
          getData={getData}
        />
      )}

{showExport && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in sm:min-w-[50%] min-w-[85%] 2xl:min-w-[40%] max-w-[50%] 2xl:max-w-[40%] max-h-[80vh] relative bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <div className=" w-full flex justify-between items-center  bg-white">
              <h2 className=" text-sm 2xl:text-base font-medium ">
                Export Data
              </h2>
              <div
                className=" cursor-pointer "
                onClick={() => setShowExport(false)}
              >
                <CloseIcon />
              </div>
            </div>
            <form onSubmit={ExportFormik.handleSubmit}>
              <div className=" w-full flex flex-wrap">
                <div className=" w-full flex ">
                  <div className=" w-1/2 flex items-center px-6 py-3 ">
                    <input
                      id="default-radio-1"
                      type="radio"
                      value="all"
                      name="type"
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                      onChange={ExportFormik.handleChange}
                      checked={ExportFormik.values.type =="all"}
                    />
                    <label
                      htmlFor="default-radio-1"
                      className="ms-2 text-xs 2xl:text-sm  text-gray-900 "
                    >
                      All Data
                    </label>
                  </div>

                  <div className="w-1/2 flex items-center px-6 py-3">
                    <input
                      id="default-radio-2"
                      type="radio"
                      value="filter"
                      name="type"
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                      onChange={ExportFormik.handleChange}
                      checked={ExportFormik.values.type == "filter"}
                    />
                    <label
                      htmlFor="default-radio-2"
                      className="ms-2 text-xs 2xl:text-sm  text-gray-900"
                    >
                      Filter Data
                    </label>
                  </div>
                </div>
                {ExportFormik.values.type === "filter" && (
                  <>
                  <FormikSelectTwo
              label="Priority"
              Options={Priority}
              formik={ExportFormik}
              placeholder="Choose"
              name="priority"

              width="w-full"
              displayProperty={"Priority"}
              propertyName={"priority"}
              getFunc={refPriority}

            /> 

<FormikSelectTwo
              label="Ticket Type"
              Options={TicketType}
              formik={ExportFormik}
              placeholder="Choose"
              name="ticketType"

              width="w-full"
              displayProperty={"Ticket Type"}
              propertyName={"Ticket_Type"}
              getFunc={refTicketType}

            /> 
           <FormikSelectTwo
              label="Status"
              Options={Status}
              formik={ExportFormik}
              placeholder="Choose"
              name="status"

              width="w-full"
              displayProperty={"Status"}
              propertyName={"Status_Support_Tickets"}
              getFunc={refStatus}
              
            />

                  </>
                )}
                <div className="flex w-full justify-end gap-2">
                  <CancelButton handleClick={closeFilterDialogebox} />
                <SubmitButton name="Export" isLoading={ExportFormik.isSubmitting} />
                </div>
              </div>
            </form>
          </div>
        </div>
      )}

       
   </>
 )
}

export default ClientTicketsIndex
